import { useEffect, useState } from 'react';
import { getChosenPassengers } from '../../../services/customer/ticketBookingServices';

function useSavedPassengers({ seatFormation }) {
  const [savedPassengers, setSavedPassengers] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      const res = await getChosenPassengers();
      if (res.status === 'success') {
        setSavedPassengers(res?.data);
      }
    };
    if (seatFormation !== 'booking') {
      fetchData();
    }
  }, []);

  return savedPassengers;
}

export default useSavedPassengers;
